import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Services")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    modelValue: _ctx.draw,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.draw) = $event)),
      _ctx.closeDraw
    ],
    temporary: "",
    theme: "dark"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_list, {
        density: "compact",
        nav: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list_item, {
            "prepend-icon": "mdi-view-dashboard",
            title: "Home",
            value: "home",
            onClick: _ctx.goto_home
          }, null, 8, ["onClick"]),
          _createVNode(_component_v_list_item, {
            "prepend-icon": "mdi-forum",
            title: "About Us",
            value: "about",
            onClick: _ctx.goto_about
          }, null, 8, ["onClick"]),
          _createVNode(_component_v_list_item, {
            "prepend-icon": "mdi-phone",
            title: "Contact Us",
            value: "contact",
            onClick: _ctx.goto_contact
          }, null, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_list, { density: "compact" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list_subheader, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allServices, (item, i) => {
            return (_openBlock(), _createBlock(_component_v_list_item, {
              key: i,
              value: item.name,
              onClick: ($event: any) => (_ctx.goto_services(item.id))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, {
                  textContent: _toDisplayString(item.name)
                }, null, 8, ["textContent"])
              ]),
              _: 2
            }, 1032, ["value", "onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "onUpdate:modelValue"]))
}